module.exports = ".painel-historico {\n    padding-left: 0px;\n    padding-right: 0px;\n}\n\n.col-md-2 {\n    width: 14.666667%;\n}\n\n.col2-md-offset-1 {\n    margin-left: 4.33% !important\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/detalhe-fta-modal/detalhe-fta-modal.component.css
// module id = ./src/app/modal/detalhe-fta-modal/detalhe-fta-modal.component.css
// module chunks = main